import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { SectionLabel } from '../ui/SectionLabel';

export const FrenchExperience = () => (
  <section className="py-28 md:py-40 bg-white overflow-hidden">
    <div className="container mx-auto px-6 md:px-14">
      <div className="flex flex-col lg:flex-row gap-16 lg:gap-24 items-center">
        <div className="w-full lg:w-1/2 order-2 lg:order-1">
          <FadeIn direction="right">
            <SectionLabel>Heritage & Craft</SectionLabel>
            <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-6 leading-tight">
              Our Story — <br />
              <span className="italic text-wine">The French Bistro Experience</span>
            </h2>
            <p className="text-gold/80 text-sm tracking-wide font-medium mb-10 leading-relaxed italic">
              "Reminiscent of the charming bistros tucked away in the hidden corners of Paris, Maison De Charm's setting and décor evoke a truly Parisian atmosphere — convivial and soulful, yet elevated with fine dining finesse."
            </p>
            <div className="space-y-8 text-charcoal/70 font-light text-base leading-relaxed">
              <p>
                Step into Maison De Charm and be welcomed by the warmth of a true French bistro — intimate, characterful, and alive with Parisian spirit. As you enter, pass by our elegant display of signed napkins from celebrated patrons, then settle into a cosy dining space adorned with beautifully crafted French artefacts and vintage posters from bygone eras.
              </p>
              <p>
                With a glass of your favourite non-alcoholic sparkling juice or wine in hand, wander through the passage beyond the kitchen, where sepia-toned photographs line the walls. Maison De Charm proudly upholds the bistro tradition of generous hospitality — where guests feel at home, yet every detail speaks of care and refinement.
              </p>
              <p>
                Our menu celebrates the very best of French bistro gastronomy — from timeless classics to seasonal creations — all elevated with fine dining presentation and precision. Every ingredient is meticulously sourced: fresh seafood, wild-caught fish, premium gourmet meats, farm-raised poultry, and vibrant produce — chosen with care to deliver an unforgettable experience.
              </p>
            </div>
          </FadeIn>
        </div>

        <div className="w-full lg:w-1/2 order-1 lg:order-2">
          <FadeIn direction="left" className="relative">
            <div className="absolute -inset-4 border border-gold/10 -rotate-2" />
            <div className="relative z-10 grid grid-cols-2 gap-4">
              <img 
                src="https://res.cloudinary.com/dfg8nrgvf/image/upload/q_auto/f_auto/v1779961742/lowerdeck_for_website_iqqpcd.png" 
                alt="Interior" 
                className="w-full aspect-[4/5] object-cover shadow-xl" 
              />
              <img 
                src="https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?q=80&w=800&auto=format&fit=crop" 
                alt="Detail" 
                className="w-full aspect-[4/5] object-cover shadow-xl mt-8" 
              />
            </div>
          </FadeIn>
        </div>
      </div>
    </div>
  </section>
);